export function citationMarkerSx(flagged) {
  const warning = 'var(--app-warning, #d83b01)'
  return {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 16,
    height: 16,
    px: 0.5,
    ml: '1px',
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 1,
    verticalAlign: 'super',
    borderRadius: '5px',
    color: flagged ? warning : 'var(--app-accent, var(--app-text-primary))',
    bgcolor: 'var(--app-bg-hover)',
    border: flagged ? `1px dashed ${warning}` : '1px solid transparent',
    '&:hover': { bgcolor: 'var(--app-bg-active)' },
  }
}
